import { render, staticRenderFns } from "./yingShouaging.vue?vue&type=template&id=5f0012aa&scoped=true&"
import script from "./yingShouaging.vue?vue&type=script&lang=js&"
export * from "./yingShouaging.vue?vue&type=script&lang=js&"
import style0 from "./yingShouaging.vue?vue&type=style&index=0&id=5f0012aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0012aa",
  null
  
)

export default component.exports